export default __webpack_public_path__ + "media/images/images_v2/left-pagination-3bd971f7920698991f99a9caed14a3e8.png";